import useSKUEntities from '~/services/loop54/hooks/useSKUEntities';
import { Loop54ProductAttributes } from '~/services/loop54/types';
import { reduceLoop54Product } from '~/services/loop54/utils';

type Arguments = {
    productNumbers: string;
    isMobile: boolean;
};

export default function useSKUResults({ productNumbers, isMobile }: Arguments) {
    return useSKUEntities(
        {
            resultsOptions: {
                filter: {
                    and: [
                        {
                            attributeName: Loop54ProductAttributes.InStockString,
                        },
                        {
                            or: productNumbers
                                ?.trim()
                                .split('\n')
                                .map((product) => {
                                    return {
                                        type: 'attribute',
                                        attributeName: Loop54ProductAttributes.SKU,
                                        value: product,
                                    };
                                }),
                        },
                    ],
                },
                sortBy: [{ type: 'relevance' }],
                take: isMobile ? 4 : 25,
            },
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
